/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

	class SublistModalController {

		static $inject = ["meevo.components.common.DataService", "$scope", "$mdDialog", "item", "parentScope", "context"]

		constructor(private dataService, private $scope, private $mdDialog, private item: any, private parentScope: any, private context: any) {
			let vm = this;
			this.$scope.item = this.item;
			this.$scope.context = this.context;

			this.$scope.canAdd = (): boolean => {
				return this.parentScope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
			}

			this.$scope.canEdit = (): boolean => {
				return this.parentScope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
			}

			this.$scope.canDelete = (): boolean => {
				return this.parentScope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
			}

			this.$scope.isAdding = (): boolean => {
				return this.parentScope.viewMode === Meevo.Model.MaintenanceFormState.Adding;
			}

			this.$scope.isEditing = (): boolean => {
				return this.parentScope.viewMode === Meevo.Model.MaintenanceFormState.Editing;
			}
		}

		/**
			* Cancels adding/edit session.
			*/
		cancel(): void {
			//this.$scope.cancel();
			//this.$mdDialog.cancel();
			this.parentScope.cancel();
		}

		/**
			* Validates the form, and then if valid, calls save on the scope.
			*/
		save(): void {
			let formCtrl = this.$scope.sublistItemForm;
			angular.forEach(formCtrl, function (value, key) {
				if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue')) {
					formCtrl[key].$dirty = true;
				}
			});
			
			if (formCtrl.$valid) {
				//this.$scope.save();
				//this.$mdDialog.hide(this.item);
				this.parentScope.save();
			}
		}
	}

	angular.module("meevo.components.controls")
		.controller("meevo.components.controls.SublistModalController", SublistModalController);
}